import request from '@/utils/request'

export async function getPhoneCode(data) {
  return request({
    url: '/api-member-action',
    method: 'post',
    data: {
      methods: 'getCaptcha',
      use: 'login',
      ...data
    }
  })
}

export async function login(data) {
  return request({
    url: '/api-member-action',
    method: 'post',
    data: {
      methods: 'login',
      ...data
    }
  })
}

export async function loginOut(data) {
  return request({
    url: '/api-member-action',
    method: 'post',
    data: {
      methods: 'logout',
      ...data
    }
  })
}

export async function queryUserInfo(data) {
  return request({
    url: '/api-member-action',
    method: 'post',
    data: {
      methods: 'getUser',
      ...data
    }
  })
}

export async function queryUserGameInfo(data) {
  return request({
    url: '/api-member-action',
    method: 'post',
    data: {
      methods: 'getUserGame',
      ...data
    }
  })
}